import React from "react";
import { Link } from "react-router-dom";
import { Eyebrow, Section } from "./SeoUI";

const PricingSection = () => {
  return (
    <Section id="pricing" className="bg-[#f7f7f7]">
      <div className="text-center">      
        <div className="flex justify-center">
          <Eyebrow>Exe_unlock_pro</Eyebrow>
        </div>
        <h2 className="font-medium tracking-[-2%] text-[36px] md:text-[28px] text-[#313131] font-inter">
          Free to start. $4.99 to unlock everything.
        </h2>
      </div>
      <div className="mx-auto mt-12 grid max-w-[850px] gap-5 md:grid-cols-2">
        <div className="rounded-xl border border-neutral-200 bg-white p-7 font-jetBrainsMono">
          <div className="flex justify-between text-[10px] md:text-[11px] tracking-[8%] text-[#5C5C5C]">
            <span>TIER_FREE</span>
            <span>MONTHLY_CREDITS</span>
          </div>
          <div className="mt-4 md:text-[36px] text-[28px] text-[#313131]">$0</div>
          <p className="font-inter mt-3 text-[11px] md:text-[13px] leading-5 text-[#5C5C5C]">
            Explore the catalog, build your profile, try Eveness end-to-end.
          </p>
          <div className="mt-6 space-y-4">
            {[
              ["TRY-ONS", "4/10", 40],
              ["AI SEARCHES", "3/10", 30],
              ["GPT CHATS", "5/15", 33],
            ].map(([l, v, p]) => (
              <div key={l}>
                <div className="flex justify-between md:text-[11px] text-[10px] text-[#5C5C5C]">
                  <span>{l}</span>
                  <span className="text-[#F26633]">{v}</span>
                </div>
                <div className="mt-1 h-1.5 rounded bg-neutral-200">
                  <div
                    className="h-full rounded bg-[#F26633]"
                    style={{ width: `${p}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
          <Link
            to="/quiz"
            className="mt-8 block rounded border border-[#313131] py-3 px-[18px] text-center text-sm hover:bg-neutral-100 opacity-[1] "
          >
            Start free
          </Link>
        </div>
        <div className="rounded-xl bg-[#303030] p-7 text-white font-jetBrainsMono">
          <div className="flex items-center justify-between font-mono text-[10px] md:text-[11px] tracking-[8%] text-white">
            <span className="opacity-[60%]">TIER_PRO</span>
            <span className="rounded-full bg-[#F26633] px-2 py-1 text-[9px] text-white h-[19px]">
              RECOMMENDED
            </span>
          </div>
          <div className="mt-4 text-[28px] md:text-4xl">
            $4.99<span className="text-sm text-[#FFFFFF99]">/mo</span>
          </div>
          <p className="mt-3 min-h-[45px] font-inter text-xs md:text-[13px] leading-5 text-[#FFFFFFB2]">
            Unlimited Try-Ons, AI Searches and GPT Chats. Priority indexing on new drops.
          </p>
          <ul className="mt-6 space-y-3 text-[12px] md:text-[13px] font-inter text-[#FFFFFFD9]">
            {[
              "Unlimited virtual try-ons",
              "Unlimited GPT styling chats",
              "Priority product indexing",
              "Boards: save unlimited looks",
              "Early access to seasonal palettes",
            ].map((x) => (
              <li className="flex gap-2" key={x}>
                <span className="text-[#f56535]">•</span>
                {x}
              </li>
            ))}
          </ul>
          <Link
            to="/eveness-pro"
            className="mt-8 block rounded bg-[#F26633] py-3 text-center text-[12px] md:text-[13px] font-medium hover:bg-[#da4e22] font-inter"
          >
            Unlock Pro — $4.99/mo
          </Link>
        </div>
      </div>
    </Section>
  );
};

export default PricingSection;
